module.exports = __webpack_public_path__ + "img/banner_1.7c772e5b.webp";